module.exports = __webpack_public_path__ + "static/meditation-cover-cbaeb82c6fe6909106d24babf4591ff1.jpg";